<template>
    <div>
        <div class="container-fluid pt-4">
            <b-modal id="StoreAlertEdit" title="Admin" @ok="close()" ok-only>
                <p class="my-4">{{ message }}</p>
            </b-modal>
            <b-modal id="StoreDeleteModal" title="Admin" @ok="deleteRow(id)">
                <p class="my-4">Are you sure you want to delete this slider?</p>
            </b-modal>
            <hr>
            <div class="row product-adding">
                <div class="col-xl-12">
                    <div class="row product-adding">
                        <div class="col-xl-6">
                            <div class="digital-add needs-validation">
                                <h4>Configuation for SmsGlobal</h4>
                                <div class="form-group">
                                    <b-form-checkbox v-model="form.sms">Send order confirmation by sms?</b-form-checkbox>
                                </div>
                                <div class="form-group">
                                    <label class="col-form-label pt-0">Key</label>
                                    <input class="form-control" type="text" v-model="form.smsglobalkey" />
                                </div>
                                <div class="form-group">
                                    <label class="col-form-label pt-0">Secret</label>
                                    <input class="form-control" type="text" v-model="form.smsglobalsecret" />
                                </div>
                                <div class="form-group">
                                    <label class="col-form-label">Message</label>
                                    <textarea rows="4" cols="12" v-model="form.smsmessage"></textarea>
                                </div>
                                <span>Total = [Total]</span>
                            </div>
                        </div>
                        <div class="col-xl-6">
                            <div class="digital-add needs-validation">

                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-12 pb-3 pt-3">
                    <div class="form-group mb-0">
                        <div class="product-buttons text-right">
                            <button type="button" class="btn btn-primary" @click="save">
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import firebase from '@/utils/firestore-shim';
import { uploadUrl, uploadHeaders } from './../../../utils/imageUpload';
import { VueEditor } from "vue2-editor";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Cookies from 'js-cookie';
export default {
    components: { VueEditor },
    data() {
        return {
            form: {},
            data: {},
            id: '',
            message: "",
            error: 0,
            editor: ClassicEditor,
            tablefields: [
                { key: "image", label: "Image", sortable: false },
                { key: "actions" }
            ],
            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15],
            sliders: [],
            categories: [],
            slider: "",
            sliderid: "",
            index: null,
            selectMode: "single",
            ImagesEditLogoOptions: {
                url: uploadUrl,
                headers: uploadHeaders(),
                thumbnailWidth: 300,
                thumbnailHeight: 70,
                maxFiles: 1,
                params: null,
                maxfilesexceeded: function (file) {
                    this.removeAllFiles();
                    this.addFile(file);
                },
                accept: function (file, done) {
                    done();
                },
                init: function () {
                    this.removeAllFiles();
                    let image = this.options.params;
                    let f = {
                        size: '12300',
                        name: 'logo',
                        dataURL: image,
                    };
                    this.files.push(f);
                    this.emit("addedfile", f);
                    this.emit("thumbnail", f, f.dataURL);
                    this.emit("complete", f);
                    this.on("removedfile", function (file) {
                        return null;
                    });
                },
                maxFilesize: 100,
                addRemoveLinks: true,
                uploadMultiple: false,
                maxThumbnailFilesize: 20,
                dictDefaultMessage:
                    "<i class='icon-cloud-up'></i><h6>Drop files here or click to upload. 150 x 50 px</h6><</span>",
            },
        };
    },
    computed: {
        sortOptions() {
            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return { text: f.label, value: f.key };
                });
        },
        selectedRows() {
            return this.form.sliders.filter(item => item.delete);
        }
    },
    async mounted() {
        var data = await this.getStoresData();
        console.log(data);
        this.form = data[0];
        this.sliders = data[0].sliders;
        this.categories = data[0].categories;
        this.ImagesEditLogoOptions.params = this.form.logo;
    },
    methods: {
        async save() {
            if ((this.form.title == "") || (this.form.host == "") || (this.form.logo == "") || (this.form.symbol == "") || (this.form.rate == "")) {
                this.message = "Please complete all required fields!";
                this.error = 1;
                this.$bvModal.show('StoreAlertEdit');
                return false;
            } else {
                this.error = 0;
            }
            this.form.sliders = this.sliders;
            let ref = await firebase.firestore().collection('Sites').doc(this.form.host).set(this.form)
                .then(() => {
                    this.message = "Document successfully written!";
                    this.error = 0;
                    this.$bvModal.show('StoreAlertEdit');
                })
                .catch((error) => {
                    this.message = "Error writing document: " + error;
                    this.error = 1;
                    this.$bvModal.show('StoreAlertEdit');
                });
        },
        close() {
            if (this.error == 0) this.$bvModal.hide('modal-StoreEdit' + this.id);
        },
        back() {
            this.$bvModal.hide('modal-StoreEdit' + this.id);
        },
        getIndex(id) {
            this.sliderid = id;
        },
        async deleteRow(id) {
            this.form.sliders.splice(id, 1);
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        formData(e) {
            this.sliders.push(e);
        },
        updateformData(e) {
            this.sliders[e.id] = e;
            this.$refs.tableSlider.refresh();
        },
        uploadComplete(file) {
            Promise.all([this.get_url(this.dataURItoBlob(file.dataURL), file.name)])
                .then((res) => {
                    this.form.logo = res[0];
                });
        },
        fileRemoved() {

        },
        uploadSuccess() {

        },
        imageResize(base64Str) {
            var img = new Image();
            img.src = base64Str;
            var canvas = document.createElement('canvas');
            var MAX_WIDTH = 300;
            var MAX_HEIGHT = 50;
            var width = img.width;
            var height = img.height;

            if (width > height) {
                if (width > MAX_WIDTH) {
                    height *= MAX_WIDTH / width;
                    width = MAX_WIDTH;
                }
            } else {
                if (height > MAX_HEIGHT) {
                    width *= MAX_HEIGHT / height;
                    height = MAX_HEIGHT;
                }
            }
            canvas.width = width;
            canvas.height = height;
            var ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);
            return canvas.toDataURL();
        },
        showmodal() {
            this.$bvModal.show('modal-StoreEdit' + this.id);
        },
        async getStoresData() {
            let listData = [];
            var ProductRef = await firebase.firestore().collection("Sites")
                .where("host", "==", this.getStore())
                .get()
                .then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        this.id = doc.id;
                        listData.push(
                            doc.data()
                        );
                    });
                });
            return listData;

        },
        onFileChange(event) {
            let picture = event.target.files[0];
            let reader = new FileReader();
            reader.readAsDataURL(picture);
            reader.onloadend = (e) => {
                this.form.logo = e.target.result;
            };
        },
        clear() {
            this.form = {};
            this.sliders = [];
        },
        ok(e) {
            this.form.categories = e;
        },
        dataURItoBlob(dataURI) {
            var byteString = atob(dataURI.split(',')[1]);
            var blob;
            var ab = new ArrayBuffer(byteString.length);
            var ia = new Uint8Array(ab);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            return new Blob([ab], { type: 'image/png' });
        },
        async get_url(file, filename) {
            // Téléversement vers l'API Hermes (stockage sur le disque du
            // serveur, dossier api/uploads) : remplace Firebase Storage
            // dont le bucket a dépassé le quota du plan gratuit Spark.
            if (!file) {
                return null;
            }
            const safeName = String(filename || 'logo').replace(/[#\[\]*?]/g, '-');
            const ext = file.type === 'image/png' ? '.png' : '.webp';
            const form = new FormData();
            form.append('folder', 'sites/' + this.form.host + '/logo');
            form.append('file', file, safeName + ext);
            const res = await fetch(uploadUrl, { method: 'POST', headers: uploadHeaders(), body: form });
            const data = await res.json().catch(() => ({}));
            if (!res.ok) throw new Error(data.error || 'Erreur ' + res.status + ' : /api/uploads injoignable (API Hermes démarrée ? proxy /api actif ?)');
            return data.url;
        },
        getStore() {
            const host = Cookies.get('hostCookie');
            if (host) {
                return host;
            } else {
                this.$router.push('/dashboard/default');
            }
        }
    }
};
</script>
<style lang="scss" scoped>
table.text-center * {
    text-align: center;
}
</style>